/*
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxLoggerLevel } from "ngx-logger";
import { EnvServiceProvider } from "../providers/environment/environment-settings";

export const environment = {
  production: false,

  // A name given to this environment profile. We can use this
  // value to emit to the application log. The name pattern is
  // following the file name format.
  name: "default",

  // The following property is a toggle. If true, then the string used within the
  // about-carecheck.component.html page is help-info-heading-excluding-consent. If
  // false, then the string used is help-info-heading. This toggle allows the
  // inclusion/exclusion of the patient consent statement from the help text.
  exclude_consent_from_help_info_heading: false,

  // The following properties control the ngx-logger.
  //
  // See: https://onthecode.co.uk/angular-logging-made-easy-with-ngx-logger/
  //      for a blog post detailing the configuration and use of the ngx-logger
  //      module.
  // See: https://www.npmjs.com/package/ngx-logger/v/3.3.8
  //      for the library documentation.
  //
  // NOTE: Application logging is enabled by default here and for
  //       our sandbox, dev, qa, and demo aws environments, but it
  //       should be turned off in stg and prod environments. Server
  //       logging is not currently used anywhere.
  apiUrl: "http://localhost:68552/",
  logLevel: EnvServiceProvider.useFactory().defaultLogLevel,
  serverLogLevel: NgxLoggerLevel.OFF,
  disableConsoleLogging: false,
  useMockData: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
